import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { ExpandableSection } from '../components/expandableSection';
import { StatsFieldsContents } from './playerInfoPanel/statsFieldsContents';
export const PlayerRestrictedStatsExpandableSectionContainer = ({ restrictedStatsFields }) => {
    if (!restrictedStatsFields || !restrictedStatsFields.length) {
        return null;
    }
    return (_jsx(ExpandableSection, { expandableSectionType: 'player-restricted-stats', colorType: 'player-info', children: _jsx(StatsFieldsContents, { statsFields: restrictedStatsFields }) }));
};
